export default defineNuxtRouteMiddleware(() => {
  const store = useMainStore();

  if (!store.userData) {
    return navigateTo('/');
  }
});
